export const BASE_URL: string = 'https://mayfairgroupapi-training.intelisys.ca/api/';
//export const BASE_URL: string = 'https://mayfairgroupapi.intelisys.ca/api/';

export const TIME_REFRESH_TOKEN: number = 14999;
export const TIME_REFRESH_FARE_RESULT: number = 30;
